import Entity from '../entity'

export default class OfferDateType extends Entity<number> {
    name: string = "";
}